import clsx from "clsx";
import { FiX, FiCheck } from "react-icons/fi";
import { SlideDown } from "transitions/slide";

export default function Alternative(props) {
  const { content, index, questionnaireAnswer, answer, revealAnswer } = props;
  const { loading, disabled } = props;

  const alphabet = String.fromCharCode(...Array(123).keys()).slice(97);
  const letter = alphabet[index];
  const selected = questionnaireAnswer?.answer == letter;
  const revealSelectedResult = questionnaireAnswer?.confirmedAt;
  const revealAsWrongAnswer =
    !loading &&
    selected &&
    !isCorrectAnswer() &&
    (revealAnswer || revealSelectedResult);
  const revealAsCorrectAnswer = !loading && revealAnswer && isCorrectAnswer();

  const disableInput = disabled || revealSelectedResult || revealAnswer;

  function handleClick() {
    if (disableInput) return;

    props.onAnswerChange(letter);
  }

  function isCorrectAnswer() {
    return letter === answer;
  }

  function statusColor() {
    return clsx({
      "text-disabled border-gray-300": !selected && !revealAsCorrectAnswer,
      "hover:text-emphasis-medium hover:border-gray-600":
        !selected && !disableInput,
      "text-primary-500 border-primary-400":
        selected && !revealAnswer && !revealSelectedResult,
      "text-success border-success": revealAsCorrectAnswer && selected,
      "text-primary-900 border-primary-900": revealAsCorrectAnswer && !selected,
      "text-error border-error": revealAsWrongAnswer
    });
  }

  return (
    <div
      className={clsx("alternative-wrapper", statusColor(), {
        "my-4": !loading && (revealAsWrongAnswer || revealAsCorrectAnswer)
      })}
    >
      <div
        className={clsx(
          "alternative fade-loading flex items-stretch px-5 text-inherit border-2 border-inherit rounded-md overflow-hidden transition-colors",
          { loading, "h-14": loading, selected },
          { "cursor-default": disableInput, "cursor-pointer": !disableInput }
        )}
        data-disabled={disabled}
        onClick={handleClick}
      >
        <div className="flex items-center mr-5 text-inherit font-semibold uppercase transition-colors">
          <Identifier
            letter={letter}
            selected={selected}
            revealAsCorrectAnswer={revealAsCorrectAnswer}
            revealAsWrongAnswer={revealAsWrongAnswer}
          />
        </div>
        <div
          className={clsx("alternative-content py-1 w-full transition-colors", {
            selected,
            reveal: revealAnswer,
            "correct-answer": revealAnswer && isCorrectAnswer()
          })}
        >
          <div dangerouslySetInnerHTML={{ __html: content }}></div>
        </div>
      </div>
      {!loading && (
        <>
          <SlideDown
            visible={revealAsWrongAnswer}
            className="text-inherit"
            timeout={300}
            disableExit={true}
          >
            <span className="block mt-1 text-emphasis-medium text-inherit">
              Resposta marcada
            </span>
          </SlideDown>
          <SlideDown
            visible={revealAsCorrectAnswer}
            className="text-inherit"
            timeout={300}
            disableExit={true}
          >
            <span className="block mt-1 text-emphasis-medium text-inherit">
              {selected || !questionnaireAnswer
                ? "Resposta certa"
                : "Resposta esperada"}
            </span>
          </SlideDown>
        </>
      )}
    </div>
  );
}

function Identifier(props) {
  const { letter, selected, revealAsCorrectAnswer, revealAsWrongAnswer } =
    props;

  if (selected && revealAsCorrectAnswer) {
    return (
      <div className="mr-[-6px] text-inherit">
        <FiCheck />
      </div>
    );
  }

  if (revealAsWrongAnswer) {
    return (
      <div className="mr-[-6px] text-inherit">
        <FiX />
      </div>
    );
  }

  return <span className="text-inherit">{letter}</span>;
}
